import { getMenuDatas, checkCustomerData } from './fetchAPI.js';
import { showNoti } from './helpers.js';

// Loading Data
jQuery(window).on('load', function () {
  jQuery('#onboarding').delay(500).fadeOut(500);
});

jQuery(document).ready(async function () {
  try {
    const menu = jQuery('#SideBarMenu');
    if (menu) {
      const menuHTML = await getMenuDatas();
      jQuery('#SideBarMenu').html(menuHTML);
    }
  } catch (error) {
    console.error('Error loading posts:', error);
    showNoti('Đã có lỗi xảy ra!', 'warn');
  }
});

jQuery(document).ready(async function () {
  const now = Math.floor(Date.now() / 1000);
  const timeRenew = localStorage.getItem('timeRenew');
  const pathname = window.location.pathname;
  const firstPathSegment = pathname.split('/').filter(Boolean)[0];
  const customerData = JSON.parse(localStorage.getItem('customerData'));
  // console.log(firstPathSegment);
  // if (!['kho-tai-lieu-cho-nha-phan-phoi', 'kho-tai-lieu-cho-khach-hang', 'redirect'].includes(firstPathSegment)) {
  //   window.location.href = 'https://course.kiem.vn';
  //   console.log('PATH KHONG HOP LE');
  // }
  // else {
  //   console.log('PATH HOP LE');
  // }
  if (firstPathSegment === 'kho-tai-lieu-cho-nha-phan-phoi') {
    if (!customerData) {
      window.location.href = 'https://course.kiem.vn';
    }
    const userID = ['KIEMSAPHIA', 'KIEMSAPHIAl', '16091999'];
    if (!userID.includes(customerData.code)) {
      if (now < timeRenew && customerData.classLevelNewPolicy === 4) {
        console.log('TRUY CAP HOP LE');
      }
      else {
        console.log('TRUY CAP KHONG HOP LE');
        window.location.href = 'https://npp.kiem.vn';
      }
    } else {
      console.log('TRUY CAP HOP LE. BAN LA ADMIN CUA HE THONG');
    }
  }
});


jQuery(document).ready(async function () {
  if (window.location.pathname === '/redirect/') {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const endPoint = params.get('endPoint');

      console.log('Token from URL:', token);
      if (token) {
        localStorage.setItem('token', token);
        const now = Math.floor(Date.now() / 1000);
        const oneDayLater = now + 86400;
        localStorage.setItem('timeRenew', oneDayLater.toString());
      }
      await checkCustomerData();
      if (endPoint) {
        window.location.href = `/${endPoint}`;
      }
    } catch (error) {
      console.error('Error loading posts:', error);
      showNoti('Đã có lỗi xảy ra!', 'warn');
    }
  }
});